module.exports = __webpack_public_path__ + "img/bg3.67782c78.png";